import AllParticipantsSummary from "../AllParticipantsSummary"

export default function ParticipantGroupSidebar() {
  return <AllParticipantsSummary />
}
